/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// ANNA's stages (her suggested next step, never the OrangeHRM status) and the
// colours the design uses for them. Keys match CandidateReviewService::STAGES.
export const STAGES = {
  awaiting_answers: {label: 'Awaiting answers', tone: 'grey'},
  answers_in_review: {label: 'Answers in review', tone: 'amber'},
  hr_scored: {label: 'HR scored', tone: 'blue'},
  proceed_to_interview: {label: 'Proceed to interview', tone: 'green'},
  rejected: {label: 'Rejected', tone: 'red'},
};

// The list's filter pills, as in the design.
// The candidate list's work queues (GET /api/v2/anna/candidates?queue=...)
export const QUEUE_PILLS = [
  {key: null, label: 'All', count: 'all'},
  {key: 'new', label: 'New', count: 'new'},
  {key: 'interviewed', label: 'Interviewed', count: 'interviewed'},
  {key: 'shortlisted', label: 'Shortlisted', count: 'shortlisted'},
  {key: 'rejected', label: 'Rejected', count: 'rejected'},
];

/** green / amber / red for a score out of `max`; grey when not scored. */
export function scoreTone(value, max = 100) {
  if (value === null || value === undefined) return 'grey';
  const pct = (value / max) * 100;
  if (pct >= 75) return 'green';
  if (pct >= 50) return 'amber';
  return 'red';
}

/** YES / NO / UNKNOWN answer checks and core skills. */
export function checkTone(value) {
  return {YES: 'green', NO: 'red'}[value] || 'grey';
}
